<template>
  <div class="sale-star">
    <div style="margin-bottom:0.8rem">
    <el-button @click="addStar" type="success" size="small" icon="el-icon-plus">添加明星</el-button>
    <el-button :loading="starLoading" size="small" @click="saveSatrs" type="primary">保存</el-button>
    </div>
    <div v-for="(msg,index) in starsDate" :key="index" class="introduction-box">
      <div class="sale-star-box">
        <span class="trend-title">团队或个人名称</span>
        <el-input maxlength="10" show-word-limit type="text" placeholder="请输入" v-model="msg.name"></el-input>
        <el-button @click="removeStar(msg.id,index)" size="small" type="danger" icon="el-icon-minus">删除</el-button>
      </div>
      <div class="sale-star-box">
        <span class="trend-title">照片</span>
        <div style="display:inline-block;">
          <el-upload 
            class="avatar-uploader"  
            :http-request="(e)=>{uploadfile(e,index)}" 
            action="#" 
            :before-upload="beforeAvatarUpload"
            :show-file-list="false">
            <img v-if="msg.picture" :src="msg.picture" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <div class="sale-star-box">
        <span class="trend-title">团队或个人介绍</span>
        <el-input maxlength="100" show-word-limit :rows="4" type="textarea" placeholder="请输入" v-model="msg.remark"></el-input>
        
      </div>
    </div>
    <!-- <div class="last-save">
      
    </div> -->
  </div>
</template>

<script>
import api from '@/apis/sale/sale'
import upapi from '@/apis/upload'
export default {
  data(){
    return{
      starLoading:false,//加载状态
      starsDate:[
        {name:'',picture:'',remark:''}
      ]
    }
  },
  mounted(){
    this.getStars()
  },
  methods:{
    //保存数据
    saveSatrs(){
      this.starLoading = true;
      api.saveStar(this.starsDate).then(res=>{
        if(res.code==10000){
          this.starLoading = false;
          this.getStars()
          this.$message.success('保存成功');
        }else{
          this.$message.error(res.message);
          this.starLoading = false;
          return;
        }
      })
    },
    //获取数据
    getStars(){
      api.getStar().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.starsDate = res.data.list
          }
        }
      })
    },
    //删除一行人员数据
    removeStar(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
         confirmButtonText: '确定',
         cancelButtonText: '取消',
         type: 'warning'
        }).then(() => {
         api.delStar([id]).then(res=>{
           if(res.code==10000){
             this.$message({
               type: 'success',
               message: '删除成功!'
             });
             this.getStars()
           }else{
             this.$message.error(res.message);
             return;
           }
         })
       })
      }else{
        this.starsDate.splice(index,1)
      }
    },
    //图片上传成功的回调函数
    uploadfile(val,i) {
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.starsDate[i].picture = res.data
        } else {
          this.$message.error(res.message)
          return;
        }
      })
    },
    //判断上传文件格式是否合法
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    //添加一行人员数据
    addStar(){
      this.starsDate.unshift({name:'',picture:'',remark:''})
    },
  }
}
</script>
<style lang="less" scoped>
.sale-star{ padding-top:10px;
  .introduction-box{display:inline-block; border: #3570ff solid 1px; position: relative; width: 30%; padding:1rem; margin-right:1rem; margin-bottom: 1rem; position: relative;
    .sale-star-box{ display:flex; flex-direction: row; margin-bottom: 15px;
      .trend-title{ width:8rem; flex-shrink: 0;}
      .el-input{ width: 100%;}
      .avatar,.avatar-uploader{ width: 6rem; height: 7rem; border: #3570ff solid 1px; vertical-align: top;}
      .avatar-uploader{ color: #fff; text-align:center; line-height: 7rem; font-size: 2rem; vertical-align: top;}
    }
  }
}
</style>